import React from "react";

import AssignmentPanel from "./AssignmentPanel";
import ModuleDescriptionPanel from "./ModuleDescriptionPanel";
import RecommendationPanel from "./RecommendationPanel";
import SuggestedContentPanel from "./SuggestedContentPanel";
import OverviewPanel from "./OverviewPanel";
import type {
  CourseEvaluatorReviewMockData,
  CourseEvaluatorReviewSidebarItemMock,
} from "../mockData/courseEvaluatorReview.mockData";

interface ReviewContentPanelProps {
  review: CourseEvaluatorReviewMockData;
  selectedReviewItem: CourseEvaluatorReviewSidebarItemMock | null;
  onStartReviewing: () => void;
}

function ReviewContentPanel({ review, selectedReviewItem, onStartReviewing }: ReviewContentPanelProps) {
  if (selectedReviewItem === null) {
    return <OverviewPanel review={review} onStartReviewing={onStartReviewing} />;
  }

  switch (selectedReviewItem.kind) {
    case "moduleDescription":
      return <ModuleDescriptionPanel selectedReviewItem={selectedReviewItem} />;
    case "recommendation":
      return <RecommendationPanel selectedReviewItem={selectedReviewItem} />;
    case "assignment":
      return <AssignmentPanel selectedReviewItem={selectedReviewItem} />;
    case "suggestedContent":
      return <SuggestedContentPanel selectedReviewItem={selectedReviewItem} />;
    default:
      return null;
  }
}

export default ReviewContentPanel;
